module.exports = new __parcel__URL__("360.027619d7.svg").toString();